import React from 'react';

interface LoadingSpinnerProps {
    size?: 'sm' | 'md' | 'lg';
    className?: string;
    text?: string;
}

const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8',
};

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
                                                                  size = 'md',
                                                                  className = '',
                                                                  text
                                                              }) => {
    return (
        <div className={`flex items-center justify-center ${className}`}>
            <div className="flex items-center space-x-2">
                <div
                    className={`${sizeClasses[size]} animate-spin rounded-full border-2 border-gray-300 border-t-blue-600`}
                    role="status"
                    aria-label="Loading"
                />
                {text && (
                    <span className="text-sm text-gray-600">{text}</span>
                )}
            </div>
        </div>
    );
};

export default LoadingSpinner;
